// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"30912443","453":"c135931e"}[chunkId] + ".chunk.js";
};